var map = {
	"./workPermit0.png": "9eb0",
	"./workPermit1.png": "93a9",
	"./workPermit2.png": "5b6f",
	"./workPermit3.png": "de03",
	"./workPermit4.png": "16de",
	"./workPermit5.png": "8aa2",
	"./workPermit6.png": "202b",
	"./workPermit7.png": "8100",
	"./workPermit8.png": "fdd7",
	"./workPermit9.png": "fab8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1273";